<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="620px" scrollable>
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>Thêm học sinh theo lớp</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <v-form v-bind="this.$attrs" ref="form">
            <div>Lớp:<span style="color: red">*</span></div>
            <AutocompleteClass
              v-model="classData"
              return-object
              label="Lớp"
              outlined
              dense
              :rules="[$rules.required]"
              hide-details="auto"
              class="required"
            />
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-space-between pa-6">
          <v-btn color="blue darken-4" text @click="cancel" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="confirm">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { StudentExam } from '@/plugins/api'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'

export default {
  props: {
    exam: String,
    state: Boolean
  },
  components: {
    AutocompleteClass
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) {
        this.loading = false
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      classData: null,
      confirmDialog: false,
      examDate: '',
      queries: [
        {
          mathExpect: false,
          engExpect: false,
          mathExempt: false,
          engExempt: false
        }
      ]
    }
  },
  methods: {
    cancel() {
      this.$emit('closeDialog')
    },
    async confirm() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        let data = {
          grade: this.classData._id,
          exam: this.exam
        }
        console.log(data)
        let create = await StudentExam.createAllMainExam(data)

        if (create === 'finished') {
          this.$emit('refresh')
          this.cancel()
        } else {
          this.$alert.error('Lỗi tạo')
        }
        this.$loading.active = false
      }
    },
    addQuery() {
      this.queries.push({
        mathExpect: false,
        engExpect: false,
        mathExempt: false,
        engExempt: false
      })
    },
    removeQuery(index) {
      this.queries.splice(index, 1)
    }
  }
}
</script>
